import { QuestionCircleOutlined } from '@ant-design/icons';
import { appTheme } from '@app/styles/app-theme';
import { Tooltip } from 'antd';
import { ReactNode } from 'react';

type FieldLabelProps = {
  label: ReactNode;
  required?: boolean;
  tooltip?: ReactNode;
};

export function FieldLabel({ label, required, tooltip }: FieldLabelProps) {
  return (
    <div className="flex items-center gap-1.5">
      <Tooltip title={String(label)} placement="topLeft" styles={{ root: { maxWidth: 300 } }}>
        <label
          className="text-ellipsis block overflow-hidden whitespace-nowrap"
          style={{ fontSize: appTheme.components?.InputNumber?.fontSize }}
        >
          {String(label)}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      </Tooltip>
      {tooltip && (
        <Tooltip title={tooltip} placement="topLeft" styles={{ root: { maxWidth: 380 } }}>
          <QuestionCircleOutlined
            className="text-gray-400 hover:text-gray-600 cursor-help flex-shrink-0"
            style={{ fontSize: 13 }}
          />
        </Tooltip>
      )}
    </div>
  );
}

export default FieldLabel;
